import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Layers, Building2, Laptop, Workflow } from 'lucide-react';
interface SlideNewCategoryProps {
  onContinue: () => void;
}
export function SlideNewCategory({
  onContinue
}: SlideNewCategoryProps) {
  const [stage, setStage] = useState(0);
  useEffect(() => {
    const t1 = setTimeout(() => setStage(1), 300);
    const t2 = setTimeout(() => setStage(2), 900);
    const t3 = setTimeout(() => setStage(3), 1700);
    const t4 = setTimeout(() => setStage(4), 2400);
    const t5 = setTimeout(() => setStage(5), 3100);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      clearTimeout(t4);
      clearTimeout(t5);
    };
  }, []);
  return <div className="h-full w-full flex flex-col items-center justify-center px-8 py-10 text-center relative overflow-hidden" data-id="element-675" data-mp="1nnoaus45wtl6">
      {/* Soft ambient glow */}
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none" data-id="element-676" data-mp="1snajeo91plnn">
        <div className="w-[700px] h-[700px] bg-teal-400/5 rounded-full blur-[100px]" data-id="element-677" data-mp="2nm2l2khc7slt" />
      </div>

      <div className="z-10 max-w-4xl w-full flex flex-col items-center" data-id="element-678" data-mp="2ijtrpn0jyoj6">
        {/* Layers icon */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.8,
        y: -10
      }} animate={{
        opacity: stage >= 1 ? 1 : 0,
        scale: stage >= 1 ? 1 : 0.8,
        y: stage >= 1 ? 0 : -10
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-679" data-mp="2dmtrvtuaqi0i">
          <div className="w-16 h-16 rounded-2xl bg-navy-700/60 border border-teal-400/30 flex items-center justify-center backdrop-blur-sm" data-id="element-680" data-mp="2wk4kivlfad6z">
            <Layers className="w-7 h-7 text-teal-400" strokeWidth={2.2} data-id="element-681" data-mp="2shroiywh9tne" />
          </div>
        </motion.div>

        {/* Eyebrow */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center space-y-4" data-id="element-682" data-mp="3ka8juqrkvqs6">
          <p className="text-teal-400 font-semibold tracking-widest uppercase text-sm" data-id="element-683" data-mp="1nazxf5cc1ii7">
            The Shift
          </p>
          <h2 className="text-4xl md:text-5xl font-serif text-white" data-id="element-684" data-mp="18lc5uvtydy7o">
            A New Category
          </h2>
        </motion.div>

        {/* Headline */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: stage >= 3 ? 1 : 0,
        y: stage >= 3 ? 0 : 20
      }} transition={{
        duration: 0.6
      }} className="text-5xl md:text-7xl lg:text-8xl font-sans font-bold text-white leading-[1.05] tracking-tight mb-8" data-id="element-685" data-mp="zmgw59rpa5zm">
          Campaign Service
          <br data-id="element-686" data-mp="2k3d8ftphsvid" />
          Management
        </motion.h2>

        {/* Gradient divider */}
        <motion.div initial={{
        width: 0,
        opacity: 0
      }} animate={{
        width: stage >= 4 ? 180 : 0,
        opacity: stage >= 4 ? 1 : 0
      }} transition={{
        duration: 0.7
      }} className="h-[3px] bg-gradient-to-r from-blue-400 via-teal-400 to-teal-300 rounded-full mb-8" data-id="element-687" data-mp="2p14ysjaho9kg" />

        {/* Subtitle */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-gradient-to-r from-teal-400/20 via-purple-500/20 to-teal-400/20 border border-teal-400/30 rounded-2xl p-10 text-center relative overflow-hidden" data-id="element-688" data-mp="ibbdrafkkwrk">
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-689" data-mp="113mdwwiuaglz" />
          <div className="relative z-10" data-id="element-690" data-mp="37uvkvf9y25uy">
            <div className="w-16 h-16 mx-auto bg-teal-400/20 rounded-2xl flex items-center justify-center mb-6 border border-teal-400/40" data-id="element-691" data-mp="32v8xid0ej98f">
              <Workflow className="w-8 h-8 text-teal-400" data-id="element-692" data-mp="34bedffwbtf2a" />
            </div>
            <h3 className="text-3xl md:text-4xl font-serif text-white mb-4" data-id="element-693" data-mp="39azlcfth4xr5">
              Campaign Service Management
            </h3>
            <p className="text-xl text-white/80 max-w-2xl mx-auto leading-relaxed" data-id="element-694" data-mp="3eb575fd2bq1b">
              Managed pharma campaign execution powered by software economics.
              We deliver the outcome, not the tool.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: stage >= 5 ? 1 : 0
      }} transition={{
        duration: 0.5
      }} className="mt-12 flex justify-center" data-id="element-695" data-mp="2qkhtedggu66u"></motion.div>
      </div>
    </div>;
}